"use client";

import { c as _c } from "react/compiler-runtime";
import { CustomLink } from "@repo/design-system/components/ui/custom-link";
import ArrowRight from "~/components/icons/arrow-right-eon";
import { useLanguage } from "~/translations/loader/use-language";
import type { JobadComponentProps } from "~/types/job";
import JobAdVideo from "../jobadvideo/jobad-video-eon";
export default function About(_props) {
  const $ = _c(13);
  const t = useLanguage();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      backgroundImage: `url(${process.env.NEXT_PUBLIC_ASSET_URL}images/jobad/about-bg.webp)`,
      backgroundSize: "cover"
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="relative aspect-video w-full lg:aspect-auto"><JobAdVideo hideControls={true} playOnLoad={true} thumbnailSrc="images/videos/about-thumbnail.webp" videoUrl="EON_Logo_Staging_Swarm_1920x1080.mp4" /></div>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t.jobad_about) {
    t2 = <p className="text-lg lg:text-xl" data-source="lc">{t.jobad_about}</p>;
    $[2] = t.jobad_about;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <ArrowRight className="h-8 pr-1" />;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t.jobad_about_button_title) {
    t4 = <p className="border-inherit border-b-2">{t.jobad_about_button_title}</p>;
    $[5] = t.jobad_about_button_title;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t.jobad_about_button_link || $[8] !== t4) {
    t5 = <CustomLink blank={true} className="mt-6 flex items-center border-foreground font-bold text-lg transition-colors duration-300 hover:border-white md:mt-12" data-source="lc" href={t.jobad_about_button_link}>{t3}{t4}</CustomLink>;
    $[7] = t.jobad_about_button_link;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t2 || $[11] !== t5) {
    t6 = <section className="flex w-full justify-center pointer-fine:bg-fixed px-10 py-10 text-foreground md:px-10 md:py-20 print:hidden" id="about" style={t0}><div className="grid h-full w-full max-w-screen-xl gap-10 bg-white p-6 md:p-10 lg:relative lg:grid-cols-2">{t1}<div><div className="flex h-full flex-col justify-center">{t2}{t5}</div></div></div></section>;
    $[10] = t2;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  return t6;
}